<template>
  <unicom-layout-cartao semFiltro>
    <div v-if="!loading">
      <ValidationObserver v-slot="{ invalid }">
        <unicom-linha>
          <unicom-coluna sm="12">
            <div class="titulo negrito cor-fonte fonte-primaria">
              Classificação
            </div>
          </unicom-coluna>
        </unicom-linha>

        <unicom-linha class="mt-4" alinharItem="end" style="min-height: 80px">
          <unicom-coluna
            sm="12"
            md="3"
            alinhamento="start"
            :class="$breakpoint.smAndDown ? 'mt-2' : ''"
          >
            <label style="min-height: 23px; display: flex"
              >Tipo de Atuação
            </label>
            <single-select
              @input="inputTipoAtuacao"
              :propsSingleSelect="{
                placeholder: '',
                options: listaTipoAtuacao,
                'track-by': 'descTipoAtuacao',
                label: 'descTipoAtuacao'
              }"
              :value="objetoClassificacao.tipoAtuacaoEdit"
            />
          </unicom-coluna>

          <unicom-coluna
            sm="12"
            md="3"
            alinhamento="start"
            v-show="dataDeixouDeSerOperadoraObrigatorio"
          >
            <ValidationProvider
              name="dataDeixouDeSerOperadoraEdit"
              :rules="{
                required: dataDeixouDeSerOperadoraObrigatorio
              }"
              immediate
            >
              <unicom-campo-calendario-v3
                fecharClique
                class="invalid"
                tituloCampo="Data em que deixou de ser Operadora"
                v-model="objetoClassificacao.dataDeixouDeSerOperadoraEdit"
              />
            </ValidationProvider>
          </unicom-coluna>

          <unicom-coluna sm="12" md="auto" alinhamento="center">
            <unicom-linha>
              <unicom-coluna
                sm="12"
                md="auto"
                :class="$breakpoint.smAndDown ? 'mt-2' : ''"
              >
                <unicom-botao
                  :bloco="$breakpoint.smAndDown"
                  :desabilitado="invalid"
                  :largura="144"
                  @click="
                    $emit('abrir-modal-justificativa', objetoClassificacao)
                  "
                >
                  SALVAR
                </unicom-botao>
              </unicom-coluna>
            </unicom-linha>
          </unicom-coluna>

          <unicom-coluna sm="12" md="auto" alinhamento="center">
            <unicom-linha>
              <unicom-coluna
                sm="12"
                md="auto"
                :class="$breakpoint.smAndDown ? 'mt-2' : ''"
              >
                <unicom-botao
                  :bloco="$breakpoint.smAndDown"
                  :largura="144"
                  @click="$emit('abrir-modal-historico-classific')"
                >
                  HISTÓRICO
                </unicom-botao>
              </unicom-coluna>
            </unicom-linha>
          </unicom-coluna>
        </unicom-linha>
      </ValidationObserver>
    </div>
    <div v-else>
      <unicom-spinner
        style="min-height: 130px; display: flex; align-items: center"
        v-show="loading"
        :tamanhoLoading="62"
        :tamanhoLinha="7"
        :velocidade="0.5"
        :marginTopTexto="30"
      />
    </div>
  </unicom-layout-cartao>
</template>

<script>
import SingleSelect from "@/views/RecursosPropriosQuestionarios/shared/Singleselect.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    SingleSelect,
    ValidationProvider,
    ValidationObserver
  },
  methods: {
    inputTipoAtuacao(valor) {
      this.objetoClassificacao.tipoAtuacaoEdit = valor;
    }
  },
  props: {
    objetoClassificacaoProp: {
      dataDeixouDeSerOperadora: "",
      tipoAtuacao: "",
      dataDeixouDeSerOperadoraEdit: "",
      tipoAtuacaoEdit: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    listaTipoAtuacao: {
      type: Array
    }
  },
  data() {
    return {
      objetoClassificacao: {
        dataDeixouDeSerOperadora: "",
        tipoAtuacao: "",
        dataDeixouDeSerOperadoraEdit: "",
        tipoAtuacaoEdit: ""
      },
      tipoAtuacaoProp: null,
      dataDeixouDeSerOperadoraObrigatorio: false
    };
  },
  computed: {},
  watch: {
    objetoClassificacaoProp: {
      deep: true,
      immediate: true,
      handler() {
        this.objetoClassificacao = JSON.parse(
          JSON.stringify(this.objetoClassificacaoProp)
        );
      }
    },
    objetoClassificacao: {
      deep: true,
      immediate: true,
      handler() {
        if (
          this.objetoClassificacao.tipoAtuacaoEdit.descTipoAtuacao ===
          "NÃO OPERADORA"
        ) {
          this.dataDeixouDeSerOperadoraObrigatorio = true;
        } else {
          this.dataDeixouDeSerOperadoraObrigatorio = false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
